// NPM imports
import React, { Component } from "react";
import { connect } from "react-redux";

import { manipulateCustomJSONThree } from "./methods";

// Components Imports
import FormField from "../PricebookItemEditor/FormField";

// Actions Import
import PricebooksActions from "../../../actions/PricebooksActions";

// Destructuring
const { updateFormRowData } = PricebooksActions;

// Component
class FinalWizardScreen extends Component {
  // to populate default values of 3rd screen in formRowData
  componentDidMount() {
    const tempFormRowData = { ...this.props.formRowData };
    this.props.customJSON.forEach(item => {
      if (
        !Object.prototype.hasOwnProperty.call(this.props.formRowData, item.fld)
      ) {
        if (item.name === "is_renewable") {
          // set value here
          if (
            tempFormRowData[this.props.fieldMapIndex.charge_type] === "One Time"
          ) {
            tempFormRowData[item.fld] = false;
          } else {
            tempFormRowData[item.fld] = true;
          }
        } else if (item.name === "sellingterm_editable") {
          // set value here
          if (
            tempFormRowData[this.props.fieldMapIndex.recurring_period] === ""
          ) {
            tempFormRowData[item.fld] = false;
          } else {
            tempFormRowData[item.fld] = true;
          }
        } else {
          tempFormRowData[item.fld] = item.defaultVal;
        }
      } else if (
        Object.prototype.hasOwnProperty.call(
          this.props.formRowData,
          item.fld,
        ) &&
        item.name === "sellingterm_editable"
      ) {
        if (tempFormRowData[this.props.fieldMapIndex.recurring_period] === "") {
          tempFormRowData[item.fld] = false;
        } else {
          tempFormRowData[item.fld] = true;
        }
      }
    });
    this.props.updateFormRowData(tempFormRowData);
  }

  render() {
    const finalCustomJSON = manipulateCustomJSONThree(
      this.props.customJSON,
      this.props.isEdit,
      this.props.formRowData,
      this.props.fieldMapIndex,
      this.props.pricingMethodData,
    );

    const heading = this.props.isEdit
      ? `Update Deal table properties`
      : `Deal table properties`;

    return (
      <div className="pricingmethodwrapper-wrapper">
        <div className="pricingmethod-title">
          <span className="pricingmethodwrapper-header">{heading}</span>
          <span className="pricingmethodwrapper-subheader">
            For {this.props.pricingMethodData.product.name}
          </span>
        </div>

        <div className="flatpriceeditor-wrapper">
          {finalCustomJSON.map(field => (
            <FormField {...field} key={field.fld} {...this.props} />
          ))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { products, metaData, formRowData, pricingMethodData } =
    state.PricebookStore;
  return {
    fieldMapIndex: metaData.fieldMapIndex,
    data: formRowData,
    products,
    pricingMethodData,
  };
};

const mapDispatchToProps = {
  updateFormRowData,
};

export default connect(mapStateToProps, mapDispatchToProps)(FinalWizardScreen);
